import { MouseEventHandler, ReactNode } from "react";
import { Box } from "@chakra-ui/react";
import { FragmentType, getFragmentData, gql } from "__generated__/gql";
import { EmailMessageParticipantType } from "__generated__/gql/graphql";
import EmailLink from "components/Shared/EmailLink";
import TagList from "components/Shared/TagList";

export const PARTICIPANT_TYPE_LABELS: Record<
  EmailMessageParticipantType,
  string
> = {
  [EmailMessageParticipantType.FROM]: "From",
  [EmailMessageParticipantType.TO]: "To",
  [EmailMessageParticipantType.CC]: "CC",
  [EmailMessageParticipantType.BCC]: "BCC",
  [EmailMessageParticipantType.RECEIVER]: "Receiver",
};

const participantsFragment = gql(/* GraphQL */ `
  fragment EmailMessageParticipants on EmailMessageParticipant {
    id
    displayName
    emailAddress {
      id
      email
    }
  }
`);

type Props = {
  isEmailShown?: boolean;
  moreLabel?: ReactNode;
  numTotal?: number;
  onMoreClick?: MouseEventHandler<HTMLAnchorElement & HTMLButtonElement>;
  participants: FragmentType<typeof participantsFragment>[] | null | undefined;
};

export default function Participants({
  isEmailShown = false,
  moreLabel,
  numTotal,
  onMoreClick,
  participants: fragmentData,
}: Props) {
  const participants = getFragmentData(participantsFragment, fragmentData);

  return (
    <TagList
      items={participants}
      getKey={(emp) => emp.id}
      getLabel={(participant) => {
        const email = (
          <EmailLink
            email={participant.emailAddress?.email}
            fontFamily="mono"
            fontSize=".9em"
          />
        );

        if (participant.displayName) {
          return (
            <>
              {participant.displayName}
              {isEmailShown && (
                <Box as="span" color="gray.600" fontWeight={300}>
                  {" "}
                  {"<"}
                  {email}
                  {">"}
                </Box>
              )}{" "}
            </>
          );
        }

        return (
          <Box as="span" fontWeight={600}>
            {email}
          </Box>
        );
      }}
      moreLabel={moreLabel}
      numTotal={numTotal}
      onMoreClick={onMoreClick}
      sx={{ ".chakra-link": { color: "inherit !important" } }}
      isTruncated
    />
  );
}
